import sanitizeHtml from 'sanitize-html';

// eslint-disable-next-line import/prefer-default-export
export function countWords(str: string, sanitizeConf = {}): number {
  if (str === '') {
    return 0;
  }
  const sanitized = sanitizeHtml(str, sanitizeConf);
  const replaced = sanitized
    .replace(/<[^>]*>/g, ' ')
    .replace('&nbsp;', ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .split(/\s/g);

  const count = replaced === [] ? 0 : replaced.length;
  return count;
}
